/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHandlerListResponse {
    getFixupPrototypeFunction() { return BackgroundJobHandlerListResponse.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHandlerListResponse>): BackgroundJobHandlerListResponse {
        let obj = Object.assign(new BackgroundJobHandlerListResponse(), model);
        BackgroundJobHandlerListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHandlerListResponse>): BackgroundJobHandlerListResponse {
        if (!model) return null;
        return BackgroundJobHandlerListResponse.newInstance(<BackgroundJobHandlerListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHandlerListResponse) {
        if (!obj) return;

        models.BackgroundJobHandlerListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHandlerListResponse): boolean {
        Object.setPrototypeOf(obj, BackgroundJobHandlerListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Active Background Job Handlers
     */
    payload_types: Array<string>;

}
